module.exports = "<div id=\"page-404\" routerLink=\"/home\">\n  <div class=\"card vertical-center\">\n    <h2 class=\"glitch\" data-text=\"404\">404</h2>\n    <h3 class=\"glitch\" [attr.data-text]=\"currentURL\">NOT FOUND</h3>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/app/page404/page404.component.html
// module id = ../../../../../src/app/page404/page404.component.html
// module chunks = main